var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.version_deprecated
    ? _c(
        "v-footer",
        {
          staticClass: "update-footer warning px-2 py-1",
          attrs: { fixed: "", app: "" }
        },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-icon", { attrs: { size: "32" } }, [_vm._v("info")]),
          _vm._v(" "),
          _c("span", { staticClass: "headline ml-2" }, [
            _vm._v("\n\t\tMise à jour disponible\n\t")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ml-3" }, [
            _vm._v(
              "\n\t\tEnregistrez votre travail en cours puis actualisez l'application\n\t"
            )
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "ml-4",
              attrs: { small: "", depressed: "", color: "white warning--text" },
              on: {
                click: function($event) {
                  return _vm.reload()
                }
              }
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("autorenew")]),
              _vm._v("\n\t\tactualiser\n\t")
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe4f0a32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe4f0a32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/app_version_checker.vue
// module id = null
// module chunks = 